<!-- 论文要求查看 -->
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">任务分组</h1>
            <div style="margin-bottom: 10px;">
                <el-button type="primary" @click="UploadPaper">创建分组</el-button>
            </div>
            <el-table :data="tableData" style="width: 100%" v-if="!flag" border="1">
                <el-table-column prop="id" label="编号" width="180" align="center">
                </el-table-column>
                <el-table-column prop="rwmc" label="任务名称" width="180" align="center"></el-table-column>
                <el-table-column prop="fzsj" label="分组截止时间" width="180" align="center"></el-table-column>
                <el-table-column prop="rwsj" label="任务截止时间" width="180" align="center"></el-table-column>
                <el-table-column prop="bmrs" label="任务人数" width="120" align="center">
                    <template slot-scope="scope">
                        <span style="color: #409EFF;">{{scope.row.bmrs}} / {{scope.row.bmzrs}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sfjr" label="是否加入" width="100" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.sfjr == 1">
                           <span style="color: #409EFF;">已加入</span>
                        </template>
                        <template v-else>
                            <span style="color: red;">未加入</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型" width="100" align="center"></el-table-column>
                <el-table-column prop="address" label="任务备注" width="180" align="center"></el-table-column>
                <el-table-column prop="address" label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.sfjr == 2">
                            <el-link type="primary" @click="join(scope.$index)" :underline="false">立即加入</el-link>
                        </template>
                        <template v-else>
                            <el-link type="primary" @click="exit(scope.$index)" :underline="false">退出</el-link>
                        </template>
                    </template>
                </el-table-column >
            </el-table>

            <el-form ref="form" :model="form" label-width="100px" v-if="flag">
                <el-form-item label="任务名称">
                    <el-select v-model="form.rwmc" @change="ssss">
                        <el-option label="2025-07-12 下午实验分组" value="a"></el-option>
                        <el-option label="2025假期手工制作" value="b"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分组截止时间" v-if="form.fzsj != null">
                    {{form.fzsj}}
                </el-form-item>
                <el-form-item label="任务截止时间" v-if="form.rwsj != null">
                    {{form.rwsj}}
                </el-form-item>
                <el-form-item label="任务人数" v-if="form.bmzrs != null">
                    <span style="color: #409EFF;">{{form.bmrs - 1}} / {{form.bmzrs}}</span>
                </el-form-item>
                <el-form-item label="说明" v-if="form.fzsj != null">
                   {{form.address}}
                </el-form-item>
                <el-form-item label="分组类型" v-if="form.rwmc != null">
                    <el-radio-group v-model="form.typeInfo">
                        <el-radio value="1" label="1">我是队长</el-radio>
                        <el-radio value="2" label="2">随机分组</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择组员" v-if="form.rwmc != null && form.typeInfo == 1">
                    <el-transfer v-model="form.zyList" :data="zyDataList" :titles="['所有成员', '已选队友']"></el-transfer>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即提交</el-button>
                    <el-button type="primary" @click="fhdata">返回</el-button>
                </el-form-item>
            </el-form>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "taskGrouping",
    data() {
        return {
            zyDataList:[
                {
                    key: 0,
                    label: "杨远洋",
                },
                {
                    key: 1,
                    label: "薛丽",
                },
                {
                    key: 2,
                    label: "刘宇奇",
                },
                {
                    key: 3,
                    label: "赵五星",
                },
                {
                    key: 4,
                    label: "赵红娟",
                },
                {
                    key: 5,
                    label: "吴雪娇",
                },
                {
                    key: 6,
                    label: "冯鹏鑫",
                },
                {
                    key: 7,
                    label: "李冉冉",
                },
            ],
            tableData: [
                {
                    id: Math.floor(Math.random() * 10152452645458),
                    rwmc: "3人一组，完成手工任务",
                    fzsj: "2025-04-01 08:00:00 至 2025-04-02 17:00:00",
                    rwsj: "2025-04-03 08:00:00 至 2025-04-03 17:00:00",
                    bmrs: 2,
                    bmzrs: 3,
                    date: "2025/06/11 - 2025/07/15",
                    sfjr: 1,
                    type: "队员",
                    address: "3人一组，完成手工任务，考验学生动手能力",
                },
                {
                    id: Math.floor(Math.random() * 10152452645458),
                    rwmc: "5人一组，完成实验",
                    fzsj: "2025-04-01 08:00:00 至 2025-04-02 17:00:00",
                    rwsj: "2025-04-03 08:00:00 至 2025-04-03 17:00:00",
                    bmrs: 2,
                    bmzrs: 3,
                    date: "2025/06/11 - 2025/07/15",
                    sfjr: 2,
                    type: "队员",
                    address: "5人一组，完成实验，考验学生动手能力",
                }
            ],
            form: {
                data: undefined,
                resource: undefined,
                desc: undefined,
            },
            map:{
                a:{
                    id: Math.floor(Math.random() * 10152452645458),
                    rwmc: "2025-07-12 下午实验分组",
                    fzsj: "2025-05-12 08:00:00 至 2025-07-11 00:00:00",
                    rwsj: "2025-07-12 14:00:00 至 2025-07-12 17:00:00",
                    bmrs: 6,
                    bmzrs: 12,
                    sfjr: 1,
                    type: "队员",
                    address: "考验学生动手能力",
                },
                b:{
                    id: Math.floor(Math.random() * 10152452645458),
                    rwmc: "2025假期手工制作",
                    fzsj: "2025-05-12 08:00:00 至 2025-07-11 00:00:00",
                    rwsj: "2025-07-12 14:00:00 至 2025-07-12 17:00:00",
                    bmrs: 6,
                    bmzrs: 9,
                    sfjr: 1,
                    type: "队员",
                    address: "考验学生动手能力",
                }
            },
            flag: false
        };
    },
    created() {},
    mounted() {},
    methods: {
        UploadPaper() {
            this.form.typeInfo = '1';
            this.flag = true;
        },

        onSubmit() {
            if(this.form.rwmc == null){
                this.$message({
                    message: "请选择任务！",
                    type: "error"
                });
                return;
            }
            this.$message({
                message: "提交成功！",
                type: "success"
            });
            console.log('this.form',this.form)
            this.tableData.push({
                rwmc: this.form.rwmc,
                fzsj: this.form.fzsj,
                rwsj: this.form.rwsj,
                bmrs: this.form.bmrs,
                bmzrs: this.form.bmzrs,
                sfjr: this.form.sfjr,
                type: this.form.typeInfo == 1?"队长":"队员",
                address: this.form.address,
                id: Math.floor(Math.random() * 10152452645458),
            });
            console.log(this.tableData)
            this.fhdata();
        },
        ssss(){
            this.form ={
                rwmc: this.map[this.form.rwmc].rwmc,
                typeInfo:"1",
                fzsj: this.map[this.form.rwmc].fzsj,
                rwsj: this.map[this.form.rwmc].rwsj,
                bmrs: this.map[this.form.rwmc].bmrs,
                bmzrs: this.map[this.form.rwmc].bmzrs,
                sfjr: this.map[this.form.rwmc].sfjr,
                type: this.map[this.form.rwmc].type,
                address: this.map[this.form.rwmc].address,
                id: Math.floor(Math.random() * 10152452645458),
            };
        },
        join(index){ //加入
            const loading = this.$loading({
                lock: true,
                text: '加载中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(()=>{
                loading.close();
                this.tableData[index].bmrs ++;
                this.tableData[index].sfjr = 1;
                this.$message({
                    message: "加入成功！",
                    type: "success"
                });
            },500);
        },
        exit(index){ //退出

            const loading = this.$loading({
                lock: true,
                text: '加载中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(()=>{
                loading.close();
                this.tableData[index].bmrs --;
                this.tableData[index].sfjr = 2;
                this.$message({
                    message: "退出成功！",
                    type: "success"
                });
            },500);
        },
        fhdata(){
            this.form = {
                rwmc: null,
                fzsj: null,
                rwsj: null,
                bmrs: null,
                bmzrs: null,
                sfjr: null,
                type: null,
                address: null,
                id: null,
            };
            this.flag = false
        }
    },
    beforeDestroy() {}
};
</script>
<style lang="less">
@import "../../styles/base.less";

.el-Require {
    .wd {
        color: @red;
    }

    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
}
</style>



// WEBPACK FOOTER //
// src/pages/taskGrouping/taskGrouping.vue